<template>
  <BonoHero />
  <div class="max-w-container px-container my-10 md:my-16 text-center">
    <h2 class="text-2xl md:text-4xl font-bold">
      Este año ir al cine tiene premios
    </h2>
    <p class="text-xl md:text-3xl font-thin">
      Compra ya tus entradas de la
      <router-link
        :to="{
          name: 'events',
          params: {
            type: 'movies',
          },
          query: {
            sectionId: '5db4e102-ffde-4a88-93e0-bade098f98b3',
          },
        }"
        class="text-amff-teal"
        >Sección Oficial</router-link
      >
      para conseguirlos
    </p>
  </div>
  <BonoHowItWorks />
  <BonoGifts />
  <BonoOffer />
</template>

<script>
import { defineComponent } from "vue";
import BonoHero from "@/components/bono/BonoHero.vue";
import BonoHowItWorks from "@/components/bono/BonoHowItWorks.vue";
import BonoGifts from "@/components/bono/BonoGifts.vue";
import BonoOffer from "@/components/bono/BonoOffer.vue";

export default defineComponent({
  components: {
    BonoHero,
    BonoHowItWorks,
    BonoGifts,
    BonoOffer,
  },
  setup() {
    return {};
  },
});
</script>
